import { createEntityAdapter } from '@reduxjs/toolkit';
import { ILanguageEdit } from 'application/editcomp/api/Language';

export const languageEditAdapter = createEntityAdapter<ILanguageEdit, number>({
  selectId: (project) => project.languageID,
  sortComparer: (a, b) => a.languageID - b.languageID,
});
